import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { DatatableComponent } from './datatable/datatable.component';
import { NbInputModule, NbLayoutModule, NbSelectModule } from '@nebular/theme';
import { ConvertMillisToMinutesSecondsPipe } from '../@core/utils/convertMillisToMinutesSeconds.pipe';

@NgModule({
  declarations: [DatatableComponent, ConvertMillisToMinutesSecondsPipe],
  imports: [
    CommonModule,
    NgxDatatableModule,
    ReactiveFormsModule,
    FormsModule,
    NbLayoutModule,
    NbSelectModule,
    NbInputModule,
  ],
  exports: [DatatableComponent, ConvertMillisToMinutesSecondsPipe],
  providers: [],
})
export class ThemeModule {}
